/* tslint:disable */
/* eslint-disable */
export enum BasicCostGroupType {
  Task = 'task',
  Budget = 'budget',
  CostType = 'costType'
}
